import { observer } from 'mobx-react';
import * as React from 'react';
import { TextField } from 'telia-front-react';
function TextfieldContainer(props) {
    const { field, helpMessage, errorMessage, callback } = props;
    const { maxLength, placeholder, isRequired, technicalParameter, enableAutocomplete, autocompleteAttributes, labelHidden, getValue, setValue, type, isDisabled, isReadOnly, isStatic, className, label } = field;
    const getAutocompleteAttribute = () => {
        const containsAttribute = (attribute) => technicalParameter === null || technicalParameter === void 0 ? void 0 : technicalParameter.toLowerCase().includes(attribute);
        if (!!autocompleteAttributes) {
            return autocompleteAttributes;
        }
        if (containsAttribute('email')) {
            return 'email';
        }
        if (containsAttribute('phone')) {
            return 'tel-local';
        }
        if (containsAttribute('person_name')) {
            return 'name';
        }
        if (containsAttribute('company_name')) {
            return 'organization';
        }
        return enableAutocomplete ? 'on' : 'off';
    };
    const input = {
        maxLength: maxLength,
        placeholder: placeholder,
        autoComplete: getAutocompleteAttribute()
    };
    return (React.createElement(TextField, { id: `field-${field.id}`, type: type, isDisabled: isDisabled, isReadOnly: isReadOnly, isStatic: isStatic, className: className, label: label, value: getValue(), helpMessage: helpMessage, errorMessage: errorMessage, input: input, onChange: (text) => {
            setValue(text);
            callback(field);
        }, required: isRequired, hideLabel: labelHidden ? 'no-break' : undefined }));
}
export default observer(TextfieldContainer);
//# sourceMappingURL=Textfield.js.map